import _ from 'lodash';

import {
    FETCH_SLIDES,
    FETCH_SLIDES_SUCCESS
} from '../actions/Slideshow';

const INITIAL_STATE = {
    slides: {},
    sortedSlides: [],
    isSlideLoading: false,
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_SLIDES:
            return { ...state, isSlideLoading: true };
        case FETCH_SLIDES_SUCCESS:
            return { ...state, isSlideLoading: false, slides: action.payload, sortedSlides: action.sorted };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SlideshowReducer.js